// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__6XBwX","trigger":"styles_trigger__SLrUU","icon":"styles_icon__NcNLa"};